<template>
  <div id="office-contact-parent" class="container-fluid">
    <div class="row">
      <div
        class="col-12 image-header"
       
        :style="{ 'background-image': 'url(' + image + ')' }"
      ></div>
    </div>
    <div class="callout-parent">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-10 col-lg-8">
            <div class="callout-panel">
              <h5 class="callout-label">{{ labels.contact }}</h5>
              <h2 class="copy-heading">{{ title }}</h2>
              <p>{{ copy }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 d-flex flex-column align-items-center justify-content-center text-center content-parent"
       
      >
        <h5 class="phone-title">
          <b>{{ labels.phone }}</b>
        </h5>
        <a :href="'tel:' + phoneNumber.replaceAll( ' ', '' )"
          ><h2 class="heading-main">
            <b>{{ phoneNumber }}</b>
          </h2></a
        >
      </div>
    </div>
  </div>
</template>

<script>

    import bgImage from "../../assets/office-contact-image.jpg";

    export default ({
        name: "call to action",
        data() {
            return {
                labels: {
                    contact:    "Contact",
                    phone:      "Phone"
                },
                title:          "Let's Chat",
                copy:           "If you are interested in placing your property on the market, or would like to chat about any of our listings, call me today.",
                phoneNumber:    "0428 195 664",
                image:  bgImage
            }
        }
    });

</script>

<style lang="scss" scoped >

     // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    #office-contact-parent {
		background-color:$color_base;
        position: relative;
        z-index: 1;
        .image-header {
            @include images( center, cover );
            min-height: 500px;
        }
        .phone-title {
            color: $color_main;
            font-size: 1.25rem;
            margin-top: 5em;
        }
        .heading-main {
            color:$text;
        }
        .callout-parent {
            left: 0;
            position: absolute;
            right: 0;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            .callout-panel {
                box-shadow: 0 10px 30px #00253230;
                background-color: #fff;
                color: $text;
                margin-bottom: 2em;
                padding: 3em;
                .callout-label {
                    color: $color_main;
                    font-size: 1.25rem;
                    font-weight: $font-weight-bold;
                    margin-bottom: 2em;
                }
            }
        }
        .content-parent {
            min-height:500px;
        }

        @media screen and ( max-width:$mobile ) {
           .callout-panel {
              padding:2em;
           }
        }
    }

</style>